module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "header-box",
    class: _vm.addBackground
  }, [_c('div', {
    staticClass: "c-header",
    class: _vm.headerClass
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [(_vm.addBackground === '') ? _c('img', {
    attrs: {
      "src": require("./images/header-logo-white-xd.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("./images/header-logo-orange-xd.png")
    }
  })])]), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        active: index == _vm.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.goUrl(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _c('div', {
    staticClass: "notice-bg"
  }, [_c('div', {
    staticClass: "notice-list"
  }, [_vm._l((_vm.noticeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-item",
      on: {
        "click": function($event) {
          return _vm.goNotice(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _c('i', [_vm._v(_vm._s(item.releaseDate.slice(0, 10)))])])
  }), (_vm.totalRecord > 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": [10, 20, 30],
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next",
      "total": _vm.totalRecord
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.pageIndex = $event
      },
      "update:current-page": function($event) {
        _vm.pageIndex = $event
      }
    }
  })], 1) : _vm._e()], 2), _c('span', {
    staticClass: "blue-shadow"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-98055e9c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98055e9c","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/announcementList.vue
// module id = 1204
// module chunks = 2